import React from "react";
import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";

class Privacy extends React.Component {
  render() {
    return (
      <div className='page-privacy'>
        <div className='back-button'>
          <Link to='/'>
            <MdArrowBack /> Back
          </Link>
        </div>
        <h2>deforest privacy, and other good stuff</h2>
        <h3>State of the service</h3>
        <p>
          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
          EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
          IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
          CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
          TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
          SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
        </p>
        <h3>Privacy</h3>
        <p>
          We do not store any data about you as a user, except for some parts
          used in logging; such as your IP address. The logs are purged
          automatically after a short while and no data is saved outside of
          this. Any data you enter on this page, such as CloudFormation
          templates and API specifications are never stored on our servers more
          than temporarily in order to process your request. Any residual data
          is purged automatically after a short while as well.
        </p>
        <h3>License</h3>
        <p>
          The{" "}
          <a
            href='https://github.com/hawry/deforest'
            target='_blank'
            rel='noopener noreferrer'
          >
            original deforest software
          </a>{" "}
          is released under the MIT license, which in short means that you;
          <ul>
            <li>
              are free to use the software for commercial and non-commercial use
            </li>
            <li>are allowed to modify the software</li>
            <li>are allowed to distribute the software</li>
          </ul>
          For details, see the LICENSE in the source code available at{" "}
          <a
            href='https://raw.githubusercontent.com/hawry/deforest/master/LICENSE'
            target='_blank'
            rel='noopener noreferrer'
          >
            https://raw.githubusercontent.com/hawry/deforest/master/LICENSE
          </a>
        </p>
      </div>
    );
  }
}

export default Privacy;
